export const SNAPSHOT = 'snapshot';
export const MANAGE_PLANS_PATH = '/manage_plans';
